<div class="page-title">
  <ng-content></ng-content>
</div>
